<div class="row" style="margin:10px 0;">
  <div class="col-md-12">
    <div class="panel panel-default">
      <div class="panel-default">
        <div class="panel-heading" (click)="isCollapsed = !isCollapsed"
             style="cursor:pointer;">
          <h4 class="panel-title">
            <a role="button">
              <span *ngIf="loading"><i class="fa fa-spinner fa-pulse"></i></span>
              <i *ngIf="isCollapsed && items.length > 0" class="pull-left fa fa-chevron-down"></i>
              <i *ngIf="!isCollapsed && items.length > 0" class="pull-left fa fa-chevron-up"></i>
              <span *ngIf="items.length === 0">No </span>
              <span *ngIf="!meta.verbose_name_plural">
                                {{ meta.verbose_name }}
                            </span>
              <span *ngIf="meta.verbose_name_plural">
                                {{ meta.verbose_name_plural }}
                            </span>
            </a>
            <div *ngIf="hasPermission && meta.type !== undefined && !loading" class="pull-right">
                <span style="cursor: pointer;" (click)="open({}, $event)">
                    Add {{ meta.verbose_name }}
                  <i class="fa fa-plus-circle"></i>
                </span>
            </div>
          </h4>
        </div>
      </div>
      <div class="panel-body" *ngIf="loading" [ngbCollapse]="isCollapsed">
        <i class="fa fa-spinner fa-pulse"></i>
      </div>
      <div class="panel-body table-responsive" *ngIf="items.length > 0 && !loading"
           [ngbCollapse]="isCollapsed">
        <table class="table table-striped">
          <thead>
          <tr>
            <ng-container *ngFor="let key of  meta.display_fields">
              <th *ngIf="meta.fields[key].type != 'field' || (meta.fields[key].type === 'field' && meta.fields[key].read_only === true)">
                {{ meta.fields[key].label }}
              </th>
            </ng-container>
            <th *ngIf="hasPermission" style="width:25px">Remove</th>
          </tr>
          </thead>
          <!-- Moved *ngFor from tbody to tr -->
          <tbody>
          <!-- This *ngFor is for Contacts, Organizations, and Mailing Addresses -->
          <ng-container *ngFor="let item of items; let itemIndex = $index">
            <tr style="border: none;">
              <td *ngFor="let key of meta.display_fields">
                <app-display-field [type]="meta.fields[key].type" [value]="item[key]"
                                   [choices]="meta.fields[key].choices"></app-display-field>
              </td>
              <td *ngIf="hasPermission" style="vertical-align: middle; cursor: pointer;"
                  (click)="delete(item)">
                <i class="fa-regular fa-times-circle fa-lg" style="padding:0px 30%;"></i>
              </td>
            </tr>
            <tr style="background: none; border: none;" *ngIf="meta.subItems?.length > 0">
              <td [attr.colspan]="meta.display_fields.length+1">
                <ng-container *ngFor="let key of meta.subItems">
                  <app-submission-inline *ngIf="item[key]" [meta]="meta.fields[key]" [items]="item[key]"
                                         [id]="item.globalid"
                                         [hasPermission]="hasPermission"></app-submission-inline>
                </ng-container>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table>
        <div *ngIf="items.length < meta.count">
          <div class="row">
            <div class="col-md-12">
              <p class="text-center">
                <button *ngIf="!loadingMore" class="btn btn-default" (click)="loadMore()">
                  Load More Records
                </button>
                                <span *ngIf="loadingMore">
                        <i class="fa fa-spinner fa-pulse"></i>
                    </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
